/* MEDIA BUYER PLANS DATA */
export const GET_PLANS = "GET_MEDIA_BUYER_PLANS";
export const SET_MEDIA_BUYER_PLANS = "SET_MEDIA_BUYER_PLANS";

/* OVERVIEW */
export const SET_MEDIA_BUYER_PLANS_PROFIT_FILTER_DATA = "SET_MEDIA_BUYER_PLANS_PROFIT_FILTER_DATA"

/* MEDIA BUYER PLANS ACTIONS */
export const DELETE_MEDIA_BUYER_PLAN = "DELETE_MEDIA_BUYER_PLAN";
export const ADD_MEDIA_BUYER_PLAN = "ADD_MEDIA_BUYER_PLAN";
export const PATCH_PLAN = "PATCH_PLAN";
export const ADD_MEDIA_BUYER_PLAN_BY_OFFER = "ADD_MEDIA_BUYER_PLAN_BY_OFFER";
export const DELETE_MEDIA_BUYER_PLAN_BY_OFFER = "DELETE_MEDIA_BUYER_PLAN_BY_OFFER";
export const GET_MEDIA_BUYER_PROFIT = "GET_MEDIA_BUYER_PROFIT";
export const SET_MEDIA_BUYER_PROFIT = "SET_MEDIA_BUYER_PROFIT";
export const PROFIT_LOADING_PROCESS = "PROFIT_LOADING_PROCESS";

/* ONLY DATA FOR ONE  */
export const GET_MEDIA_BUYER_PLAN_FOR_ID = "GET_MEDIA_BUYER_PLAN_FOR_ID";
export const SET_MEDIA_BUYER_PLAN_FOR_ID = "SET_MEDIA_BUYER_PLAN_FOR_ID";

/* FILTERED */
export const GET_FILTERED_MEDIA_BUYER_PLAN = "GET_FILTERED_MEDIA_BUYER_PLAN";

/* LOADER */
export const SHOW_MEDIA_BUYER_PLANS_LOADER = "SHOW_MEDIA_BUYER_PLANS_LOADER";
export const HIDE_MEDIA_BUYER_PLANS_LOADER = "HIDE_MEDIA_BUYER_PLANS_LOADER";

/* ERRORS */
export const SET_ERROR_MEDIA_BUYER_PLANS = "SET_ERROR_MEDIA_BUYER_PLANS";

/* INIT */
export const INIT_MEDIA_BUYER_PLANS = "INIT_MEDIA_BUYER_PLANS"

/* PARAMS */
export const GET_MEDIA_BUYER_PLANS_PARAMS = "GET_MEDIA_BUYER_PLANS_PARAMS"
export const SET_PLANS_OFFER = "SET_PLANS_OFFER"
export const SHOW_MEDIA_BUYER_PLANS_PARAMS_LOADER = "SHOW_MEDIA_BUYER_PLANS_PARAMS_LOADER"
export const HIDE_MEDIA_BUYER_PLANS_PARAMS_LOADER = "HIDE_MEDIA_BUYER_PLANS_PARAMS_LOADER"

export const SET_MEDIA_BUYER_PLANS_NESTING = "SET_MEDIA_BUYER_PLANS_NESTING" // used for deepening (all offer_plans => all plans by offer)
export const GET_MEDIA_BUYER_PLANS_FILTER_DATA = "GET_MEDIA_BUYER_PLANS_FILTER_DATA"
export const SET_MEDIA_BUYER_PLANS_FILTER_DATA = "SET_MEDIA_BUYER_PLANS_FILTER_DATA"
export const PATCH_MEDIA_BUYER_PLANS_FILTER_DATA = "PATCH_MEDIA_BUYER_PLANS_FILTER_DATA"
export const SHOW_MEDIA_BUYER_PLANS_FILTER_DATA_LOADER = "SHOW_MEDIA_BUYER_PLANS_FILTER_DATA_LOADER"
export const HIDE_MEDIA_BUYER_PLANS_FILTER_DATA_LOADER = "HIDE_MEDIA_BUYER_PLANS_FILTER_DATA_LOADER"

/* Add custom profit local table */

export const EDIT_CUSTOM_PROFIT_LOCAL = "EDIT_CUSTOM_PROFIT_LOCAL"
export const CLOSE_CUSTOM_PROFIT_LOCAL = "CLOSE_CUSTOM_PROFIT_LOCAL"


/* Vouchers */

export const ADD_MEDIA_BUYER_VOUCHER = "ADD_MEDIA_BUYER_VOUCHER"
export const UPDATE_MEDIA_BUYER_VOUCHER = "UPDATE_MEDIA_BUYER_VOUCHER"
export const DELETE_MEDIA_BUYER_VOUCHER = "DELETE_MEDIA_BUYER_VOUCHER"
export const TRIGGER_MEDIA_BUYER_VOUCHER = "TRIGGER_MEDIA_BUYER_VOUCHER"

/* PAYOUT DATA */
export const GET_PAYOUT_CONDITIONS_MEDIA_BUYER = "GET_PAYOUT_CONDITIONS_MEDIA_BUYER";
export const SET_PAYOUT_CONDITIONS_MEDIA_BUYER = "SET_PAYOUT_CONDITIONS_MEDIA_BUYER";
export const UPDATE_PAYOUT_CONDITIONS_MEDIA_BUYER = "UPDATE_PAYOUT_CONDITIONS_MEDIA_BUYER";
export const DELETE_PAYOUT_CONDITIONS_MEDIA_BUYER = "DELETE_PAYOUT_CONDITIONS_MEDIA_BUYER";
export const ADD_PAYOUT_CONDITIONS_MEDIA_BUYER = "ADD_PAYOUT_CONDITIONS_MEDIA_BUYER";
export const PAYOUT_LOADER_MEDIA_BUYER = "PAYOUT_LOADER_MEDIA_BUYER";
